/* global debounce, trapFocus */

if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.empty === 'false') this.init();
    }

    init() {
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.cartDrawer = document.getElementById('cart-drawer');
      this.itemStatus = document.getElementById('cart-line-item-status');
      this.currentTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0
      );

      // this.currentQuantities = [];
      // this.querySelectorAll('.cart-item').forEach((item) => {
      //   this.currentQuantities[item.dataset.variantId] = Number(item.querySelector('.qty-input__input').value);
      // });

      this.currentQuantities = [];
      this.querySelectorAll('.cart-item').forEach((item) => {
        const quantityInput = item.querySelector('.qty-input__input');
        // Bundle rows such as cart-bundle-temp don't have a quantity selector.
        if (!quantityInput) return;
        const variantId = item.dataset.variantId;
        if (!variantId) return;
        this.currentQuantities[variantId] = Number(quantityInput.value) || 0;
      });

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', debounce(this.handleChange.bind(this)));
      this.updateQuantityButtons();
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('.js-remove-item')) return;
      evt.preventDefault();
      this.updateQuantity(evt.target.dataset.index, 0);
    }

    /**
     * Handles 'change' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      this.updateQuantity(evt.target.dataset.index, evt.target.value, document.activeElement.name);
    }

    /**
     * Updates the quantity of a line item.
     * @param {number} line - Line item index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
  async updateQuantity(line, quantity, name) {
      const cartDrawerContent = this.cartDrawer
        ? this.cartDrawer.querySelector('.drawer__content')
        : null;

      const cartDrawerUpsellTabbing = this.cartDrawer
        ? this.cartDrawer.querySelector('.cart_upsell_tab_wrp_main')
        : null;

      const cartDrawerContentScroll = cartDrawerContent
        ? cartDrawerContent.scrollTop
        : 0;

      const cartDrawerScroll = this.cartDrawer
        ? this.cartDrawer.scrollTop
        : 0;

      this.enableLoading(line);

      // Clear all errors except this line's error
      const lineErrorsId = `line-item-error-${line}`;
      let lineErrors = document.getElementById(lineErrorsId);

      document
        .querySelectorAll(
          `.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`
        )
        .forEach((el) => {
          el.innerHTML = '';
          el.hidden = true;
        });

      const sections = this.getSectionsToRender().map(
        (section) => section.section
      );

      this.fetchRequestOpts.body = JSON.stringify({
        line,
        quantity,
        sections: [...new Set(sections)],
        sections_url: window.location.pathname
      });

      try {
        const lineItem = document.getElementById(`cart-item-${line}`);

        if (!lineItem) {
          throw new Error('Cart item not found');
        }

        const variantId = Number(lineItem.dataset.variantId);

        /*
        * IMPORTANT:
        * Store the current quantity BEFORE Shopify updates the cart.
        */
        const quantityInputBefore = lineItem.querySelector(
          '.qty-input__input'
        );

        /*
        * IMPORTANT:
        * The input may already contain the user's manually entered
        * value, e.g. 55.
        *
        * Therefore NEVER use input.value as previousQuantity.
        * currentQuantities contains the last quantity confirmed by Shopify.
        */
        const previousQuantity = Number(
          this.currentQuantities[variantId] ??
          quantityInputBefore?.getAttribute('value') ??
          0
        );

        const oldTotalQuantity = this.currentTotalItemCount;

        const response = await fetch(
          theme.routes.cartChange,
          this.fetchRequestOpts
        );

        const data = await response.json();

        /*
        * Shopify availability error example:
        *
        * Only 50 items were added to your cart due to availability.
        */
        const errorMessage =
          typeof data.errors === 'string'
            ? data.errors
            : typeof data.description === 'string'
              ? data.description
              : typeof data.message === 'string'
                ? data.message
                : '';

// Shopify can return either:
// "Only 1 item was added..."
// "Only 2 items were added..."
const availabilityMatch = errorMessage.match(
  /only\s+(\d+)\s+items?\s+(?:was|were)\s+added.*availability/i
);

const availabilityError = Boolean(availabilityMatch);

        /*
        * Throw only real errors.
        *
        * Availability errors are handled as a warning because
        * Shopify has actually updated the cart.
        */
        if (!response.ok && !availabilityError) {
          throw new Error(errorMessage || response.status);
        }

        /*
        * ============================================================
        * GET ACTUAL QUANTITY
        * ============================================================
        *
        * Example:
        *
        * User requests: 60
        * Shopify has:   50
        *
        * actualQuantity must become 50.
        */
// Fallback when Shopify's warning response does not contain cart items.
// Example: previous quantity 1 + "Only 1 item was added" = 2.
let actualQuantity = availabilityMatch
  ? previousQuantity + Number(availabilityMatch[1])
  : previousQuantity;

      /*
      * First try the response returned by Shopify.
      */
      if (Array.isArray(data.items)) {
        const updatedItem = data.items[Number(line) - 1];

        if (updatedItem) {
          actualQuantity = Number(updatedItem.quantity);
        }
      }

      /*
      * If Shopify availability response doesn't contain items,
      * fetch the current cart.
      */
      let cartData = data;

      if (
        availabilityError ||
        !Array.isArray(data.items) ||
        typeof data.item_count !== 'number'
      ) {
        try {
// Prevent an old cached cart quantity from being returned.
const cartResponse = await fetch(`/cart.js?t=${Date.now()}`, {
  headers: {
    Accept: 'application/json'
  },
  cache: 'no-store'
});

          if (cartResponse.ok) {
            cartData = await cartResponse.json();

            /*
            * Shopify cart lines are 1-based.
            * cart.items is 0-based.
            */
            if (Array.isArray(cartData.items)) {
              const updatedItem =
                cartData.items[Number(line) - 1];

              if (updatedItem) {
                actualQuantity = Number(updatedItem.quantity);
              } else if (Number(quantity) === 0) {
                actualQuantity = 0;
              }
            }
          }
        } catch (cartError) {
          console.warn(
            'Unable to fetch updated cart:',
            cartError
          );
        }
      }

      /*
      * Safety fallback.
      */
      if (!Number.isFinite(actualQuantity)) {
        actualQuantity = previousQuantity;
      }

      /*
      * ============================================================
      * GET ACTUAL TOTAL QUANTITY
      * ============================================================
      */
      let newTotalQuantity = Number(cartData.item_count);

      if (!Number.isFinite(newTotalQuantity)) {
        newTotalQuantity = oldTotalQuantity;
      }

      /*
      * ============================================================
      * CART DRAWER EMPTY STATE
      * ============================================================
      */
      if (this.cartDrawer) {
        if (cartDrawerContent) {
          cartDrawerContent.classList.toggle(
            'drawer__content--flex',
            newTotalQuantity === 0
          );
        }

        if (cartDrawerUpsellTabbing) {
          cartDrawerUpsellTabbing.classList.toggle(
            'cart-drawer--empty',
            newTotalQuantity === 0
          );
        }

        if (newTotalQuantity === 0) {
          const recommendations =
            this.cartDrawer.querySelector(
              'product-recommendations'
            );

          if (recommendations) {
            recommendations.remove();
          }
        }
      } else if (newTotalQuantity === 0) {
        // Cart page
        const cartMain = this.closest('.cc-main-cart');

        if (cartMain) {
          const cartTitle =
            cartMain.querySelector('.js-cart-title');

          if (cartTitle) {
            cartTitle.style.textAlign = 'center';
          }
        }

        const cartSummaryCss =
          document.getElementById('cart-summary-css');

        if (cartSummaryCss) {
          cartSummaryCss.remove();
        }

        const cartSummary =
          document.getElementById('cart-summary');

        if (cartSummary) {
          cartSummary.hidden = true;
        }
      }

      /*
      * ============================================================
      * UPDATE SECTIONS
      * ============================================================
      *
      * Availability responses may NOT contain data.sections.
      * Therefore always check before accessing it.
      */
      // if (data.sections && !availabilityError) {
      //   this.getSectionsToRender().forEach((section) => {
      //     const sectionEl =
      //       document.getElementById(section.id);

      //     if (!sectionEl) return;

      //     const { selector } = section;
      //     const sectionHTML =
      //       data.sections[section.section];

      //     if (!sectionHTML) return;

      //     const el =
      //       sectionEl.querySelector(selector) ||
      //       sectionEl;

      //     el.innerHTML =
      //       CartItems.getElementHTML(
      //         sectionHTML,
      //         selector
      //       );
      //   });
      //   this.updateQuantityButtons();
      // }

      /*
 * Refresh the rendered cart sections.
 *
 * Shopify may split one variant into multiple cart lines when
 * different discount allocations apply. Availability-error
 * responses usually do not contain sections, so request fresh
 * sections after Shopify has finished updating the cart.
 */
if (availabilityError) {
  /*
   * Wait for Shopify and the discount app to finish splitting
   * the discounted quantity into its separate cart line.
   */
  await new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  /*
   * Use the drawer's native full refresh. The local
   * this.refresh() method can return an empty cart-items section
   * when called from a product page.
   */
  if (
    this.cartDrawer &&
    typeof this.cartDrawer.refresh === 'function'
  ) {
    await this.cartDrawer.refresh(true);

    /*
     * Restore Shopify's availability warning after the drawer
     * has generated its new HTML.
     */
    requestAnimationFrame(() => {
      const refreshedError =
        document.getElementById(lineErrorsId);

      if (refreshedError) {
        refreshedError.textContent =
          errorMessage;

        refreshedError.hidden = false;
      }
    });

    /*
     * Stop here because cartDrawer.refresh() replaced this
     * cart-items component with a new component.
     */
    return;
  }

  // Fallback for the full cart page.
  await this.refresh();

  lineErrors =
    document.getElementById(lineErrorsId);
} else if (data.sections) {
  this.getSectionsToRender().forEach((section) => {
    const sectionEl =
      document.getElementById(section.id);

    if (!sectionEl) return;

    const sectionHTML =
      data.sections[section.section];

    if (!sectionHTML) return;

    const el =
      sectionEl.querySelector(section.selector) ||
      sectionEl;

    el.innerHTML =
      CartItems.getElementHTML(
        sectionHTML,
        section.selector
      );
  });

  this.updateQuantityButtons();
}

      /*
      * ============================================================
      * IMPORTANT:
      * AFTER sections are rendered, explicitly set the quantity
      * input to Shopify's ACTUAL quantity.
      *
      * This is the main fix for the blank input issue.
      * ============================================================
      */
      requestAnimationFrame(() => {
        const updatedInput =
          document.getElementById(`quantity-${line}`);

        if (updatedInput) {
          updatedInput.value = actualQuantity;
          updatedInput.dataset.initialValue =
            actualQuantity;

          const quantityInput =
            updatedInput.closest('quantity-input');

          if (quantityInput) {
            quantityInput.currentQty =
              actualQuantity;
          }
        }
        this.updateQuantityButtons();
      });

      /*
      * Also set it immediately in case requestAnimationFrame
      * is not enough for the theme's quantity component.
      */
      const updatedInput =
        document.getElementById(`quantity-${line}`);

      if (updatedInput) {
        updatedInput.value = actualQuantity;
        updatedInput.dataset.initialValue =
          actualQuantity;

        const quantityInput =
          updatedInput.closest('quantity-input');

        if (quantityInput) {
          quantityInput.currentQty =
            actualQuantity;
        }
      }
      this.updateQuantityButtons();

      /*
      * ============================================================
      * EMPTY DRAWER STYLING
      * ============================================================
      */
      if (
        this.cartDrawer &&
        newTotalQuantity === 0
      ) {
        if (cartDrawerContent) {
          cartDrawerContent.classList.add(
            'grow',
            'flex',
            'items-center'
          );
        }

        if (
          this.cartDrawer.querySelector(
            'promoted-products'
          )
        ) {
          const drawerContent =
            this.cartDrawer.querySelector(
              '.drawer__content'
            );

          if (drawerContent) {
            drawerContent.classList.toggle(
              'drawer__empty-with-promotions',
              true
            );
          }
        }
      }

      /*
      * ============================================================
      * RECOMMENDATIONS
      * ============================================================
      */
      const firstProductId =
        Array.isArray(cartData.items) &&
        cartData.items.length
          ? cartData.items[0].product_id
          : null;

      this.updateRecommendations(firstProductId);

      this.updateLiveRegions();

      this.setFocus(
        line,
        newTotalQuantity,
        name
      );

      this.dataset.empty =
        newTotalQuantity === 0;

      this.currentTotalItemCount =
        newTotalQuantity;

      /*
      * ============================================================
      * LINE ITEM CHANGE EVENT
      * ============================================================
      */
      if (oldTotalQuantity !== newTotalQuantity) {
        this.dispatchEvent(
          new CustomEvent(
            'on:line-item:change',
            {
              bubbles: true,
              detail: {
                cart: cartData,
                variantId,
                oldQuantity:
                  previousQuantity,
                newQuantity:
                  actualQuantity
              }
            }
          )
        );
      }

      /*
      * Save Shopify's actual quantity.
      */
      this.currentQuantities[variantId] =
        actualQuantity;

      /*
      * ============================================================
      * AVAILABILITY MESSAGE
      * ============================================================
      *
      * DO NOT clear the error if Shopify returned an
      * availability warning.
      */
      if (availabilityError) {
        if (lineErrors) {
          lineErrors.textContent =
            errorMessage;
          lineErrors.hidden = false;
        }
      } else {
        if (lineErrors) {
          lineErrors.innerHTML = '';
          lineErrors.hidden = true;
        }
      }

      } catch (error) {
        if (lineErrors) {
          if (/^[0-9]+$/.test(error.message)) {
            lineErrors.textContent =
              theme.strings.cartError;
          } else {
            lineErrors.textContent =
              error.message;
          }

          lineErrors.hidden = false;
        }

        console.log(error); // eslint-disable-line

        this.querySelectorAll(
          '.cart-item__loader'
        ).forEach((loader) => {
          loader.hidden = true;
        });

        this.dispatchEvent(
          new CustomEvent(
            'on:cart:error',
            {
              bubbles: true,
              detail: {
                error: error.message
              }
            }
          )
        );

      /*
      * Restore the previous quantity if the request
      * actually failed.
      */
      const input =
        document.getElementById(
          `quantity-${line}`
        );

      if (input) {
        const cartItem =
          document.getElementById(
            `cart-item-${line}`
          );

        if (cartItem) {
          const currentInput =
            cartItem.querySelector(
              '.qty-input__input'
            );

          if (
            currentInput &&
            currentInput.value !== ''
          ) {
            input.value =
              currentInput.value;

            input.dataset.initialValue =
              currentInput.value;

            const quantityInput =
              input.closest(
                'quantity-input'
              );

            if (quantityInput) {
              quantityInput.currentQty =
                Number(
                  currentInput.value
                );
            }
          }
        }
      }

      } finally {
        this.classList.remove(
          'pointer-events-none'
        );

        /*
        * Hide loaders.
        */
        this.querySelectorAll(
          '.cart-item__loader'
        ).forEach((loader) => {
          loader.hidden = true;
        });

        /*
        * Maintain cart drawer scroll position.
        */
        if (cartDrawerContent) {
          requestAnimationFrame(() => {
            cartDrawerContent.scrollTop =
              cartDrawerContentScroll;
          });

          setTimeout(() => {
            cartDrawerContent.scrollTop =
              cartDrawerContentScroll;
          }, 0);

          requestAnimationFrame(() => {
            if (this.cartDrawer) {
              this.cartDrawer.scrollTop =
                cartDrawerScroll;
            }
          });

          setTimeout(() => {
            if (this.cartDrawer) {
              this.cartDrawer.scrollTop =
                cartDrawerScroll;
            }
          }, 0);
        }
      }
    }

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refresh() {
      const errors = document.getElementById('cart-errors');
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
const response = await fetch(
  `?sections=${[...new Set(sections)]}`,
  {
    headers: {
      Accept: 'application/json'
    },
    cache: 'no-store'
  }
);

        // The status is 400, refresh the whole cart and stop
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refresh(true);
          return;
        }

        const data = await response.json();

        if (!response.ok) throw new Error(response.status);

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);
        });

        this.updateQuantityButtons();

        const firstCartItem = this.querySelector('.cart-item:first-child');
        this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);

        errors.innerHTML = '';
        errors.hidden = true;
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = false;
        console.log(error); // eslint-disable-line

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'free-shipping-notice',
          section: 'free-shipping-notice',
          selector: '.free-shipping-notice'
        }
      ];

      // if (this.cartDrawer) {
      //   const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
      //   sections = [
      //     ...sections,
      if (this.closest('cart-drawer')) {
        const cartDrawerId = this.closest('cart-drawer').closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: cartDrawerId,
            selector: 'cart-items'
          },
          {
            id: 'cart-promoted-products',
            section: cartDrawerId,
            selector: '#cart-promoted-products'
          },
          {
            id: 'cart-drawer',
            section: cartDrawerId,
            selector: '.cart-drawer__summary'
          },
          {
            id: 'cart-drawer-media-promotion',
            section: cartDrawerId,
            selector: '#cart-drawer-media-promotion'
          },
          {
            id: 'cart-upsell-section',
            section: cartDrawerId,
            selector: '#cart-upsell-section'
          }
        ];
      } else {
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: this.dataset.section,
            selector: 'cart-items'
          },
          {
            id: 'cart-summary',
            section: document.getElementById('cart-summary').dataset.section,
            selector: '.cart__summary'
          },
          {
            id: 'cart-page-upsell-section',
            section: this.dataset.section,
            selector: '#cart-page-upsell-section'
          }
        ];
      }

      return sections;
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading(line) {
      this.classList.add('pointer-events-none');

      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      if (loader) loader.hidden = false;

      document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');
    }

    /**
     * Updates the cart recommendations.
     * @param {string} productId - The product id for which to find recommendations.
     */
    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      if (productId) {
        this.recommendations.dataset.productId = productId;
        this.recommendations.init();
      } else {
        this.recommendations.innerHTML = '';
      }
    }

    /**
     * Updates the live regions.
     */
    // updateLiveRegions() {
    //   this.itemStatus.setAttribute('aria-hidden', 'true');

    //   const cartStatus = document.getElementById('cart-live-region-text');
    //   cartStatus.setAttribute('aria-hidden', 'false');

    //   setTimeout(() => {
    //     cartStatus.setAttribute('aria-hidden', 'true');
    //   }, 1000);
    // }
updateLiveRegions() {
  /*
   * Cart HTML may have been replaced by refresh(), so retrieve
   * the current elements instead of relying on old references.
   */
  this.itemStatus =
    document.getElementById('cart-line-item-status');

  const cartStatus =
    document.getElementById('cart-live-region-text');

  if (this.itemStatus) {
    this.itemStatus.setAttribute(
      'aria-hidden',
      'true'
    );
  }

  if (!cartStatus) return;

  cartStatus.setAttribute(
    'aria-hidden',
    'false'
  );

  setTimeout(() => {
    /*
     * Confirm that the element is still connected because another
     * cart refresh might have replaced it during the timeout.
     */
    if (cartStatus.isConnected) {
      cartStatus.setAttribute(
        'aria-hidden',
        'true'
      );
    }
  }, 1000);
}

    updateQuantityButtons() {
      const variantTotals = {};

        /*
        * Calculate total quantity for each variant
        * across ALL cart lines.
        */
        this.querySelectorAll('quantity-input').forEach((quantityInput) => {
          const variantId = quantityInput.dataset.variantId;
          const input = quantityInput.querySelector('.qty-input__input');

          if (!variantId || !input) return;

          const quantity = Number(input.value) || 0;

          variantTotals[variantId] =
            (variantTotals[variantId] || 0) + quantity;
        });

        /*
        * Now update every + button.
        */
      this.querySelectorAll('quantity-input').forEach((quantityInput) => {
        const input = quantityInput.querySelector('.qty-input__input');
        const plusButton = quantityInput.querySelector(
          '.qty-input__btn[name="plus"]'
        );

        if (!input || !plusButton) return;

        const variantId = quantityInput.dataset.variantId;

        const currentQuantity = Number(input.value) || 0;

        /*
        * Total quantity of this variant across
        * all cart lines.
        */
        const totalVariantQuantity =
          variantTotals[variantId] || currentQuantity;

        /*
        * Inventory limit.
        */
        const inventoryQuantity =
          quantityInput.dataset.inventoryQuantity !== undefined
            ? Number(quantityInput.dataset.inventoryQuantity)
            : null;

        /*
        * Theme Add-to-cart limit.
        */
        const maxQuantity =
          quantityInput.dataset.maxQuantity !== undefined
            ? Number(quantityInput.dataset.maxQuantity)
            : null;

        /*
        * Calculate remaining limits.
        */
        let inventoryReached = false;
        let maxReached = false;

        if (Number.isFinite(inventoryQuantity)) {
          inventoryReached =
            totalVariantQuantity >= inventoryQuantity;
        }

        if (Number.isFinite(maxQuantity)) {
          maxReached =
            totalVariantQuantity >= maxQuantity;
        }

        /*
        * Disable + if either limit has been reached.
        */
        const shouldDisable =
          inventoryReached || maxReached;

        plusButton.disabled = shouldDisable;

        if (shouldDisable) {
          plusButton.setAttribute('aria-disabled', 'true');
        } else {
          plusButton.removeAttribute('aria-disabled');
        }
      });
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     * @param {number} line - Line item index.
     * @param {number} itemCount - Item count.
     * @param {string} name - Active element name.
     */
    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;

      if (lineItem) {
        activeEl = lineItem.querySelector(`[name="${name}"]`);
      }

      if (this.cartDrawer) {
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        } else if (itemCount === 0) {
          trapFocus(
            this.cartDrawer.querySelector('.js-cart-empty'),
            this.cartDrawer.querySelector('a')
          );
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }
  }

  customElements.define('cart-items', CartItems);
}





// ✅ Put this AFTER the block that defines the element
// Safely expose the constructor (works whether the block ran or not)
window.CartItems = customElements.get('cart-items');

document.addEventListener('dispatch:cart-items:refresh', async () => {
  const cartItemsEl = document.querySelector('cart-items');
  if (!cartItemsEl) return;

  try {
    const sectionName = cartItemsEl.dataset.section; // e.g. "main-cart-drawer"
    const res = await fetch(`?sections=${sectionName}`);
    const data = await res.json();

    // Replace ONLY the cart items HTML
    cartItemsEl.innerHTML = window.CartItems.getElementHTML(
      data[sectionName],
      'cart-items'
    );
    cartItemsEl.updateQuantityButtons();
  } catch (err) {
    console.error('Cart line items refresh failed:', err);
  }
});


